// Le toast : la confirmation sombre en bas à gauche (téléchargement terminé,
// relances envoyées, client créé…), avec une action facultative (Ouvrir,
// Annuler, Voir).

import "./toast.css";

import { ComptaIcone } from "@app/components/compta/ui/ComptaIcone";

interface ComptaToastProps {
  titre: string;
  sousTitre?: string;
  action?: string;
  onAction?: () => void;
}

export function ComptaToast({
  titre,
  sousTitre,
  action,
  onAction,
}: ComptaToastProps) {
  return (
    <div className="ctoast" role="status">
      <ComptaIcone
        nom="check"
        taille={16}
        style={{ color: "var(--c-vert-etat)", flexShrink: 0 }}
      />
      <div>
        <div className="ctoast__titre">{titre}</div>
        {sousTitre && <div className="ctoast__sous-titre">{sousTitre}</div>}
      </div>
      {action && (
        <>
          <div className="ctoast__separateur" />
          <button type="button" className="ctoast__action" onClick={onAction}>
            {action}
          </button>
        </>
      )}
    </div>
  );
}
